var menuImages = [
  "https://cdn.shopify.com/s/files/1/0682/5653/0607/files/home.png?v=1744732583",
  "https://cdn.shopify.com/s/files/1/0682/5653/0607/files/about.png?v=1744732583",
  // "https://cdn.shopify.com/s/files/1/0682/5653/0607/files/collection.png?v=1744732584"
  "https://cdn.shopify.com/s/files/1/0682/5653/0607/files/e990a93a0ef95b17ceb079611e5b47d9.png?v=1745017942",
  "https://cdn.shopify.com/s/files/1/0682/5653/0607/files/white_bg.jpg?v=1745018154"

];
var isMobile = window.screen.width < 768;
document.addEventListener("DOMContentLoaded", function () {
  const hamburgerBtn = isMobile ? document.getElementById("mobileMenuBtn") : document.querySelector(".hamburger-menu");
  const menuSection = isMobile ? document.getElementById("menu-overlay-wrapper") : document.querySelector(".menu-overlay-wrapper");
  console.log("menu", menuSection);
  const closeBtn = isMobile ? document.getElementById("menu-close-icon") : document.querySelector(".menu-close-icon");
  

  const mobileMenuSection = document.getElementById("mobileMen");

  // Hide the menu by default
  if (menuSection) {
    menuSection.style.display = "none";
  }

  // Toggle menu visibility on hamburger click
  if (hamburgerBtn && menuSection) {
    hamburgerBtn.addEventListener("click", function () {
      if (menuSection.style.display === "none" || menuSection.style.display === "") {
        menuSection.style.display = isMobile ? "grid" : "flex"; // Show menu
      } else {
        menuSection.style.display = "none"; // Hide menu
      }
    });
  }

  // Close menu on close icon click
  if (closeBtn && menuSection) {
    closeBtn.addEventListener("click", function () {
      menuSection.style.display = "none"; // Hide menu
    });
  }

  // Change image on hover over menu items
    var menuItems = isMobile ? document.querySelectorAll('.menu-nav-list-mobile li') : document.querySelectorAll('.menu-nav-list li');
   menuItems.forEach((item, index) => {
    var subMenu = isMobile ? document.getElementById('sub-menu_view-mobile'): document.getElementById('sub-menu_view');
    var hovImage = isMobile ? document.getElementById('hover-image-mobile') : document.getElementById('hover-image');
    
    if (isMobile) {
      item.addEventListener('touchstart', (ev) => {
        
        const imgSrc = menuImages[index];
        if (index === 1) {
          ev.preventDefault();
          hovImage.style.visibility = "hidden";
          hovImage.style.display = "none";
          subMenu.style.display = "grid";
          subMenu.style.visibility = "visible";
        } else {
          
        }
      });
    } else {
      item.addEventListener('mouseover', (ev) => {
        const imgSrc = menuImages[index];
        if (index === 1) {
          hovImage.style.visibility = "hidden";
          hovImage.style.display = "none";
          subMenu.style.display = "flex";
          subMenu.style.visibility = "visible";
        } else {
          hovImage.style.visibility = "visible";
          hovImage.style.display = "block";
          subMenu.style.visibility = "hidden";
          subMenu.style.display = "none";
          hovImage.src = imgSrc;
        }
      });
    }
  });
});


 



document.addEventListener('DOMContentLoaded', function() {
    const signUpButton = document.querySelector('.sign-up-button');
    const newsletterPopup = document.querySelector('.wpbingo-section--newsletter');
    
    if (signUpButton && newsletterPopup) {
        signUpButton.addEventListener('click', function() {
            newsletterPopup.style.display = 'block';
        });
        
        const closeButton = document.querySelector('.close-popup');
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                newsletterPopup.style.display = 'none';
            });
        }
    }
});




// Mobile Menu


